<template>
    <md-menu md-align-trigger class="button-group" :md-close-on-click="true">
        <div class="button-group-header">

            <slot name="main-button"></slot>
            <md-button class="md-primary" md-menu-trigger>
                <md-icon>arrow_drop_down</md-icon>
            </md-button>
        </div>
        <md-menu-content class="button-group-content">
            <slot name="content"></slot>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        name: "ButtonGroup"
    }
</script>

<style lang="scss">
    .button-group-content {
        .md-menu-content-container {
            .md-list {
                padding: 0;
            }

            .md-button {
                margin-left: 0;
                margin-right: 0;
            }

            .md-button:first-of-type {
                margin-top: 0;
            }

            .md-button:last-of-type {
                margin-bottom: 0;
            }
        }

    }

    .button-group-header {
        .md-button:first-of-type {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
            margin-right: 0;
        }

        .md-button:last-of-type {
            min-width: 22px;
            width: 22px;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
            margin-left: 0;

            .md-ripple {
                width: 100%;
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
        }
    }
</style>